<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2" v-if="carrito.length > 0">
          <div class="box-style line-top">
            <div class="box-header"><!-- agregar en este div la clase "disabled" cuando muestra el modulo de mercadopago -->
              <h1><span class="hide">1.</span> DETALLES DE TU PEDIDO</h1>
              <div class="box-date"><a href="" type="button" class="regular" @click.prevent="cancelarClicked"><i class="fa fa-times" ></i> cancelar pedido</a></div>
              <div class="box-date"></div>
            </div>
            
            <!-- Step1: Detalles de su pedido - Datos de envio /// Ocultar cuando se activa el paso 2. Pagar con tarjeta de crédito -->
            <div class="checkout-step1">

              <!-- separar pedidos por fecha -->
              <div class="order-per-day" v-for="item in carrito"> 
                <div class="box-body">
                  <div v-if="!estaCompletoMenuDia(item.fecha) && proveedores" class="pull-right">
                    <span class="label label-danger" >El menú no está completo para el día</span>
                  </div>
                  <div class="checkout-alert">
                    <span class="">LA EMPRESA ABONA EL {{getPorcentajeSubsidio(item.fecha)}}% DEL VALOR DE TUS PEDIDOS</span>
                    <span class="hide">LA EMPRESA ABONARÁ EL 50% DEL VALOR DE TUS PEDIDOS DE TU RECIBO DE SUELDO</span>
                  </div>
                  
                  <div class="date">
                    <span>{{item.fecha | formatearFecha}}</span>
                  </div>
                  <div class="row" v-for="proveedor in item.proveedor" :key="proveedor._id">   
                    <!-- orden de pedido -->  
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-for="plato in proveedor.platos" :key="plato._id" style="padding-top: 5px;">
                      <div class="box-order">
                        <div class="box-order-photo" :style="{backgroundImage: 'url(' + plato.plato.urlThumb + ')'}"></div>
                        <div class="box-order-detail">
                          <p class="box-order-category">{{plato.plato.categoria.nombre}}</p>
                          <p class="box-order-name" :class="{'text-danger':noDisponibles.indexOf(plato.plato._id)>=0}"> {{plato.plato.nombre}}
                          <span class="label label-danger" v-if="noDisponibles.indexOf(plato.plato._id)>=0">Sin stock suficiente</span>
                          </p>
                          <div class="box-order-foot">
                            <!-- <span class="box-order-price">$15.99</span> -->
                            <div class="quantity">
                              <!-- <a class="decrease" href="javascript:void(0);">–</a> -->
                              <span class="qty-value">{{plato.cantidad}}</span>
                              <!-- <a class="increase" href="javascript:void(0);">+</a> -->
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div><!-- fin orden de pedido -->    
                  </div>
                </div>
                <div class="box-bottom total" v-if="precioCombo">
                  <!--<span>Subtotal: {{precioCombo.precio | formatearMoneda }}</span>-->
                  
                  <span class="hide"><b>-</b> Descuento: $63.98 <b>=</b></span>
                  <!--<span class=""><b>-</b> Subsidio: {{getSubsidioDia(item.fecha) | formatearMoneda}} <b>=</b> {{getSubtotal(item.fecha) | formatearMoneda}}</span>-->
                  <span class="total-value">Total del día: {{getSubtotal(item.fecha) | formatearMoneda}}</span>
                  <br>
                </div>
              </div><!-- FIN separar pedidos por fecha -->

              <div class="box-bottom total final">
                <!--<span>SUBTOTAL: {{subtotalPedido | formatearMoneda}}</span>-->
                <span>GENERAL</span>
                <span class="hide"><b>-</b> DESCUENTO: $63.98 <b>=</b></span>
                <!--<span class=""><b>-</b> SUBSIDIO: {{subtotalSubsidios | formatearMoneda}} <b>=</b></span>-->
                <span class="total-value">TOTAL: {{subtotalGeneral | formatearMoneda}}</span>
              </div>
              <div class="box-header">
                <h1>DATOS DE ENVÍO</h1>
              </div>
              <div class="box-body" v-if="user._id">
                <div class="box-text">
                  <p class="text-size-18">Recibe <span class="semibold">{{user.displayName}}</span></p>
                  <p class="text-size-18"><span class="semibold">{{user.sucursalAsociada.empresa.razonSocial}} - {{user.sucursalAsociada.denominacion}}</span></p>
                  <p class="text-size-18">{{user.sucursalAsociada.direccion.direccion}}</p>
                </div>
                <div class="box-actions text-center smart-form">
                    <p class="text-center margin-bottom-20">
                      <label class="checkbox inline-block">
                        <input type="checkbox" name="checkbox" v-model="aceptaCondiciones">
                        <i></i>He revisado el pedido y es exactamente lo que quiero recibir
                      </label>
                    </p>
                  <button type="button" class="btn btn-primary btn-fill" :class="{disabled: !puedeConfirmarPedido}" @click.prevent="onClickConfirmar">CONFIRMAR</button>
                </div>
              </div>
            </div><!-- Fin Step1 -->
            
            <!-- Paso 2 - pago por mercadopago 
            <div class="checkout-step2 hide">
              <div class="box-header">
                <h1>2. PAGAR CON TARJETA DE CRÉDITO</h1>
                <div class="box-date"><img class="mplogo" src="/images/icons/mercadopago.svg"></div>
              </div>
              <div class="box-body mercadopago">
                <div class="row">
                  <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
                    <div class="mp-aside">
                      <p class="regular">
                        - Pedido N° 212558<br/>
                        - Lunes 14/03/2017<br/>
                        - José Gonzalez
                      </p>
                      <p class="size-16 regular">
                        <span>TOTAL:</span>
                        <span class="pull-right"><b>$127.97</b></span>
                      </p>
                    </div>  
                  </div>
                  <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
                    <form class="form smart-form form-horizontal">
                      <div class="form-group">
                      <label for="method" class="col-sm-4 control-label">Medio de Pago: *</label>
                      <div class="col-sm-6">
                        <div class="select">
                          <select id="method">
                            <option value="">Elija...</option>
                            <option value="">Visa</option>
                            <option value="">Mastercard</option>
                            <option value="">American Express</option>
                            <option value="">Naranja</option>
                            <option value="">Cabal</option>     
                          </select>
                          <i class="fa fa fa-angle-down"></i>
                        </div>
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="card" class="col-sm-4 control-label">Número de Tarjeta: *</label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" id="card" placeholder="">
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="month" class="col-sm-4 control-label">Fecha vencimiento: *</label>
                      <div class="col-sm-3">
                        <div class="select">
                          <select id="month" placeholder="MM">
                            <option value="">MM</option>
                            <option value="">01</option>
                            <option value="">02</option>
                            <option value="">03</option>
                            <option value="">04</option>
                            <option value="">05</option>
                            <option value="">06</option>
                            <option value="">07</option>
                            <option value="">08</option>
                            <option value="">09</option>
                            <option value="">10</option>
                            <option value="">11</option>
                            <option value="">12</option>
                          </select>
                          <i class="fa fa fa-angle-down"></i>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div class="select">
                          <select id="year" placeholder="AAAA">
                            <option value="">AAAA</option>
                            <option value="">2017</option>
                            <option value="">2018</option>
                            <option value="">2019</option>
                            <option value="">2020</option>
                            <option value="">2021</option>
                            <option value="">2022</option>
                            <option value="">2023</option>
                            <option value="">2024</option>
                            <option value="">2025</option>
                            <option value="">2026</option>
                            <option value="">2027</option>
                            <option value="">2028</option>
                          </select>
                          <i class="fa fa fa-angle-down"></i>
                        </div>
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="name" class="col-sm-4 control-label">Nombre y Apellido: *</label>
                      <div class="col-sm-6">
                        <input type="text" class="form-control" id="name" placeholder="Tal cual como figura en su tarjeta">
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="dni" class="col-sm-4 control-label">Documento: *</label>
                      <div class="col-sm-3">
                        <div class="select">
                          <select id="dni" placeholder="DNI">
                            <option value="">DNI</option>
                            <option value="">LC</option>
                            <option value="">LE</option>
                          </select>
                          <i class="fa fa fa-angle-down"></i>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <input type="text" class="form-control" id="dni_num" placeholder="">
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="dni" class="col-sm-4 control-label">Cód. Seguridad: *</label>
                      <div class="col-sm-2">
                        <input type="text" class="form-control" id="codseg" placeholder="">
                      </div>
                      <div class="col-sm-6">
                        <span class="text-block size-12 margin-top-10 block regular">Últimos 3 números que figuran al dorso.</span>
                      </div>
                      </div>
                      <div class="form-group">
                      <label for="dni" class="col-sm-4 control-label">Cuotas: *</label>
                      <div class="col-sm-4">
                        <div class="select">
                          <select id="dni" placeholder="DNI">
                            <option value="">Elije...</option>
                            <option value="">1 Cuota sin interés</option>
                            <option value="">3 Cuotas</option>
                            <option value="">6 Cuotas</option>
                            <option value="">12 Cuotas</option>
                          </select>
                          <i class="fa fa fa-angle-down"></i>
                        </div>
                      </div>
                      </div>
                      <div class="form-group">
                      <div class="col-sm-offset-4 col-sm-8">
                        <button type="submit" class="btn btn-primary btn-fill">CONFIRMAR PAGO</button>
                      </div>
                      </div>
                      <div class="clear-sm"></div>
                       <div class="form-group">
                        <div class="col-sm-offset-4 col-sm-8">
                          <p class="size-12 regular">Al continuar, afirmo que soy mayor de edad y acepto los <a href="#" target="_blank">términos y condiciones</a> y las <a href="#" target="_blank">políticas de privacidad</a> de MercadoPago.</p>
                        </div>
                        </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            Fin pago por mercadopago -->
          </div>
        </div>
      </div>
    </div>
  </section>  
</template>
<script>
  import 'sweetalert2/dist/sweetalert2.css'
  import swal from 'sweetalert2'
  import moment from 'moment'
  import mixinCarrito from '../../mixins/Carrito'
  export default {
    mixins: [mixinCarrito],
    data () {
      return {
        aceptaCondiciones: false,
        precioCombo: null,
        proveedores: null,
        proveedor: null,
        subsidio: null,
        noDisponibles: [],
        precioUnitario: null
        // precioCombo: null,
        // proveedores: []
        // subsidio: null
        // user: undefined
      }
    },
    props: ['carrito', 'user'],
    filters: {
      formatearFecha (value) {
        return moment(new Date(value)).utc().format('DD/MM/YYYY')
      },
      formatearMoneda (value) {
        return '$ ' + parseFloat(value).toFixed(2)
      }
    },
    computed: {
      estanCompletosPedidos () {
        const me = this
        let resultado = false
        if (!me.proveedores) {
          return resultado
        }
        if (me.carrito.length > 0) {
          resultado = me.carrito.every((itemCarrito) => {
            return me.estaCompletoMenuDia(itemCarrito.fecha)
          })
        }
        return resultado
      },
      idCombo () {
        const me = this
        if (me.carrito.length < 1) {
          return null
        }
        return me.carrito[0].combo
      },
      /*
      proveedor () {
        const me = this
        if (!me.proveedores) {
          return []
        }
        let proveedor = me.proveedores.find((prov) => {
          return me.idCombo === prov.combo
        })
        return proveedor
      },
      proveedores () {
        if (!this.user) {
          return null
        }
        return this.user.sucursalAsociada.proveedores
      },
      */
      puedeConfirmarPedido () {
        return this.aceptaCondiciones && this.estanCompletosPedidos
      }
    },
    methods: {
      cancelarClicked (e) {
        const me = this
        swal({
          title: 'Cancelar pedido',
          text: '¿Desea cancelar el pedido?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, cancelar',
          cancelButtonText: 'No, cerrar esta ventana'
        }).then(() => {
          me.$emit('vaciar-carrito')
          me.$emit('esconder-carrito')
          me.$router.push({
            path: '/hacerpedido'
          })
        }, (dismiss) => {
          return false
        })
      },
      estaCompletoMenuDia (fecha) {
        console.log('estaCompletoMenuDia')
        const me = this
        let result = false
        const subsidio = me.subsidio
        const reglas = me.reglas
        const diaCarrito = me.getDiaCarrito(fecha)
        if (diaCarrito && subsidio && reglas) {
          result = me.reglas.every((regla) => {
            let cantidadEnCarrito = me.cantidadPlatosCategoriaDia(fecha, regla.categoria._id)
            return regla.cantidad === cantidadEnCarrito
          })
        }
        return result
      },
      onClickConfirmar () {
        const me = this
        if (me.puedeConfirmarPedido) {
          me.$emit('activar-modal')
          me.$emit('esconder-carrito')
          console.log(me.carrito)
          me.$http.post('/api/pedidos', {
            carrito: me.carrito
          }).then((response) => {
            me.$emit('vaciar-carrito')
            me.$router.push({
              path: '/mispedidos'
            })
          }, (err) => {
            me.$emit('cerrar-modal')
            console.log('error', err)
            me.noDisponibles = err.body.platos
            me.$emit('mostrar-notificacion', err.body.error, 'error')
          })
        }
      }
    },
    created () {
      const me = this
      console.log('created', this)
      if (me.carrito.length < 1) {
        return
      }
      let idCombo = me.carrito[0].combo
      me.proveedores = me.user.sucursalAsociada.proveedores
      me.proveedor = me.proveedores.find((proveedor) => {
        return proveedor.combo._id === idCombo
      })
      me.reglas = me.carrito[0].reglas
      me.precioCombo = me.proveedor.proveedor.precios.find((precio) => {
        return precio.combo === idCombo
      })
      let {subsidio} = me.proveedores.find((proveedor) => {
        return proveedor.combo._id === idCombo
      })
      me.subsidio = subsidio
    },
    mounted () {
      const me = this
      me.$emit('esconder-carrito')
      /*
      const me = this
      this.$http.get('/api/pedidos/subsidiouser').then(({body}) => {
        console.log(body)
        me.proveedores = body[0].proveedores
        // me.subsidio = proveedor.subsidio
      }, (error) => {
        console.log('error', error)
      })
      */
    },
    beforeRouteLeave (to, from, next) {
      this.$emit('esconder-carrito')
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// Checkout.vue?4749c7b7